export function ArrowSVG() {
  return (
    <svg fill="none" height={40} viewBox="0 0 24 24" width={40} xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g id="SVGRepo_tracerCarrier" strokeLinejoin="round" />
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M6 12H18M6 12L11 7M6 12L11 17"
          stroke="#FFFFFF"
          strokeLinejoin="round"
          strokeWidth="2"
        />{' '}
      </g>
    </svg>
  );
}
